import { render, staticRenderFns } from "./CouponKiko.vue?vue&type=template&id=1f4b633e&scoped=true"
import script from "./CouponKiko.vue?vue&type=script&lang=js"
export * from "./CouponKiko.vue?vue&type=script&lang=js"
import style0 from "./CouponKiko.vue?vue&type=style&index=0&id=1f4b633e&lang=less&scoped=true"
import style1 from "./CouponKiko.vue?vue&type=style&index=1&id=1f4b633e&lang=scss"
import style2 from "./CouponKiko.vue?vue&type=style&index=2&id=1f4b633e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b633e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f4b633e')) {
      api.createRecord('1f4b633e', component.options)
    } else {
      api.reload('1f4b633e', component.options)
    }
    module.hot.accept("./CouponKiko.vue?vue&type=template&id=1f4b633e&scoped=true", function () {
      api.rerender('1f4b633e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCoupon/CouponKiko.vue"
export default component.exports